import { CheckboxFormField } from '@/components/shared/components/NewContextForms/CheckboxFormField';

export const DataProtectionOptInField = () => {
  return (
    <CheckboxFormField
      name="optIn"
      label="IBERIA_CARDS_DATA_PROTECTION_OPT_IN"
      labelProps={{ forceSingleLine: false }}
    />
  );
};
